const layoutActions = {
  UPDATE_FULL_SCREEN: 'UPDATE_FULL_SCREEN',
  UPDATE_SHOW_LABELS: 'UPDATE_SHOW_LABELS',
  UPDATE_LAYOUT: 'UPDATE_LAYOUT',
  TOGGLE_RIBBON: 'TOGGLE_RIBBON',
  UPDATE_ACTIONS: 'UPDATE_ACTIONS',
  UPDATE_TABS: 'UPDATE_TABS',
  UPDATE_TITLE: 'UPDATE_TITLE',
};

export const trackingCookie = {
  NAME: 'fairTrackingCookie',
  TOAST_ID: '700c23f2',
};

export const containerShell = { config: { component: '', componentState: { category: '', code: null } } };

export default layoutActions;
